import React from "react";
import { Menu, MenuProps } from "antd";
import moment from "moment";
import { Button, Icon, Dropdown } from "Components";
import { CampaignData } from "../..";
import { CAMPAIGN_STATUS_STYLES } from "../../PhishingManager.constants";

export interface CampaignItem {
  id: number;
  name: string;
  image_url: string;
  status: string;
  schedule_datetime: string;
  campaign_duration: number | string;
}

interface CampaignListProps {
  campaigns: CampaignData[];
  onMenuClick: (campaign: CampaignData) => NonNullable<MenuProps["onClick"]>;
}

const CampaignList: React.FC<CampaignListProps> = ({
  campaigns,
  onMenuClick,
}) => {
  return (
    <div className="pm-campaigns-card">
      {campaigns.map((item) => {
        const status = item?.campaign_type === "test" && item?.status === "Live" ? "Testing" : item?.status ?? '';
        const { color, background } = CAMPAIGN_STATUS_STYLES[status] || { color: "black", background: "transparent" };
        const itemStatus = (item?.status ?? '').toLowerCase();
        const hideDropdown = (["stale", "archived"].includes(itemStatus));
        return (
          <div className="pm-card-row" key={item.id}>
            <div className="pm-card-icon">
              <img alt={item.name} src={item.image_url} />
            </div>

            <div className="campaign-card">
              <div className="pm-campaign-card">{item.name}</div>
              <span className="campaign-card-status" style={{ color, background }}>{status}</span>
              <div className="pm-row-stretch">
                <Icon type="campaignCalendar" />
                <span className="pm-card-date">
                  {`${moment(item.schedule_datetime).format("M/D/YYYY")} - ${moment(item.schedule_datetime).add(Number(item.campaign_duration), "days").format("M/D/YYYY")}`}
                </span>
              </div>
            </div>

            <Dropdown
              disabled={hideDropdown}
              overlayClassName="pm-custom-dropdown-overlay"
              getPopupContainer={(trigger) => trigger.parentElement || document.body}
              overlay={
                <Menu onClick={onMenuClick(item)}>
                  {((status === "Complete") || (status === "Live")) && <Menu.Item key="report">
                    View report
                  </Menu.Item>}
                  {((item.status === "Testing" || item.status === "Live" || item.status === "Complete" || item.status === "Scheduled")) &&
                  <Menu.Item key="view-setup-summary">
                    View setup summary
                  </Menu.Item>}
                  {((item.campaign_type === 'test') && (item.status === "Testing" || item.status === "Live" || item.status === "Failed")) && <Menu.Item key="rerun">
                    Re-run test
                  </Menu.Item>}
                  {(item.campaign_type === 'test') && (item.status === "Testing" || item.status === "Live") &&
                    <Menu.Item key="release">
                      Release full campaign
                    </Menu.Item>}
                  {(((item.campaign_type === 'test') && (item.status === "Draft" || item.status === "Testing" || item.status === "Live")) || item.status === "Scheduled" || item.status === "Cancelled" || item.status === "Failed") && <Menu.Item key="discard">Discard campaign</Menu.Item>}
                </Menu>
              }
              trigger={["click"]}
            >
              <Button
                shape="round"
                ghost
                type="primary"
                size="small"
                thinVertical
              >
                <Icon type="more" />
              </Button>
            </Dropdown>
          </div>
        )
      })}
    </div>
  );
};

export default CampaignList;